import { getConfigWithMetadata } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils/error';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import { type GetSearchAlertForDisplayParams } from '@pkgs/api/models';
import {
  deleteSearchAlertPublic as generatedDeleteSearchAlertPublic,
  type DeleteSearchAlertPublicParams,
  getSearchAlertForDisplayLegacy as generatedGetSearchAlertForDisplay,
  type SearchAlertDisplayResponse,
} from '@generated/search-bff';

/**
 * Fetch detailed property information by its listing ID (UUID) using the `/api/v2/listing/{listingId}` endpoint.
 *
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/searchAlerts/getSearchAlertForDisplay Search API Documentation}
 */
export async function getSearchAlertForDisplay(
  searchAlertId: string,
  params: GetSearchAlertForDisplayParams,
  apiConfig: ApiConfig,
): Promise<ApiResult<SearchAlertDisplayResponse, SearchAlertDisplayResponse>> {
  const _apiConfig = getConfigWithMetadata(apiConfig, 'getSearchAlertForDisplay');

  try {
    const searchAlert = await generatedGetSearchAlertForDisplay(searchAlertId, params, _apiConfig);

    return {
      status: 'success',
      data: searchAlert,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    throw getErrorResult<SearchAlertDisplayResponse>(error);
  }
}

/**
 * Fetch detailed property information by its listing ID (UUID) using the `/api/v2/listing/{listingId}` endpoint.
 *
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/searchAlerts/deleteSearchAlertPublic Search API Documentation}
 */
export async function deleteSearchAlertPublic(
  searchAlertId: string,
  params: DeleteSearchAlertPublicParams,
  apiConfig: ApiConfig,
): Promise<ApiResult<void, void>> {
  const _apiConfig = getConfigWithMetadata(apiConfig, 'deleteSearchAlertPublic');

  try {
    const searchAlert = await generatedDeleteSearchAlertPublic(searchAlertId, params, _apiConfig);

    return {
      status: 'success',
      data: searchAlert,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    throw getErrorResult<void>(error);
  }
}
